export default __webpack_public_path__ + "static/media/bf.07ab1498.svg";